import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { SvgIcon } from "../SvgIcon";
export var Google = function Google(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.14 9.368V6.69h6.877c.102.454.183.878.183 1.475 0 4.113-2.814 7.035-7.053 7.035C4.093 15.2.8 11.974.8 8S4.092.8 8.147.8c1.983 0 3.644.712 4.915 1.879l-2.087 1.987C10.447 4.176 9.521 3.6 8.147 3.6 5.715 3.6 3.73 5.58 3.73 8.007s1.984 4.406 4.416 4.406c2.814 0 3.85-1.907 4.041-3.037h-4.05v-.008h.001z",
    fill: "currentColor"
  }));
};
export default Google;